import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfettiRight = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 72,
	height: 44,
	fill: "none",
	viewBox: "0 0 72 44",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#pet__clip0_15397_22443)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: props.color,
				d: "M26.8357 2.88895L29.4876 7.74511L28.0171 15.8352C28.0171 15.8352 32.8113 8.15404 45.1571 6.21942C57.5029 4.28481 63.5923 8.24123 63.5923 8.24123L53.7967 -4.94134C53.7967 -4.94134 59.5043 -8.61961 45.8435 -6.89724C32.1828 -5.17487 26.8357 2.88895 26.8357 2.88895Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: props.color,
				d: "M64.0925 39.7843L66.8167 37.818L71.802 38.0895C71.802 38.0895 66.8107 35.7846 64.7078 28.494C62.6048 21.2034 64.5259 17.2346 64.5259 17.2346L57.3282 24.1367C57.3282 24.1367 54.6789 20.9776 56.7538 29.0764C58.8286 37.1753 64.0925 39.7843 64.0925 39.7843Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: props.color,
				d: "M23.1899 38.3563L21.3577 35.5402L21.8702 30.5738C21.8702 30.5738 19.3264 35.4478 11.9426 37.1955C4.55879 38.9431 0.68755 36.8322 0.68755 36.8322L7.23329 44.3555C7.23329 44.3555 3.94964 46.8488 12.1394 45.1683C20.3292 43.4878 23.1899 38.3563 23.1899 38.3563Z"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "pet__clip0_15397_22443",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 72,
			height: 44,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgConfettiRight);
export default ForwardRef;
